// extracted by mini-css-extract-plugin
module.exports = {"container":"TextArea_container__1ePP0","label":"TextArea_label__2YH0m","input":"TextArea_input__2m81s","error":"TextArea_error__3zN5T"};